module.exports = __webpack_public_path__ + "img/product-shot_03.6f0e21d9.jpg";